type ExtractParams<T extends (params: unknown) => string> = T extends (params: infer P) => string ? P : never

export type LiftedLinks<TLinks extends Record<string, (param: unknown) => string>, TParams, X> = {
  [P in keyof TLinks]: TLinks[P] extends () => string
    ? X extends true
      ? (params: TParams) => string
      : () => string
    : (params: TParams & ExtractParams<TLinks[P]>) => string
}

export function prependPathWithParams<TLinks extends Record<string, (params: unknown) => string>>(
  fn: () => string,
  links: TLinks
): LiftedLinks<TLinks, unknown, false>
// eslint-disable-next-line no-redeclare
export function prependPathWithParams<TLinks extends Record<string, (params: unknown) => string>, TParams>(
  fn: (params: TParams) => string,
  links: TLinks
): LiftedLinks<TLinks, TParams, true>
// eslint-disable-next-line no-redeclare
export function prependPathWithParams<TLinks extends Record<string, (params: unknown) => string>, TParams>(
  fn: (() => string) | ((params: TParams) => string),
  links: TLinks
) {
  function mapLink<TLocalParams>(link: (params: TLocalParams | unknown) => string) {
    return (params: TParams & TLocalParams) => `/${fn(params)}${link(params)}`
  }

  return Object.assign({}, ...Object.keys(links).map((key) => ({ [key]: mapLink(links[key]) })))
}
